module.exports = __webpack_public_path__ + "static/media/rejected.a7a43a92.png";